import { Stack, Typography } from "@mui/material";
import { Dispatch, useCallback } from "react";
import React from "react";
import { IMutator } from "sonobello.utilities.react";

import Modal from "../../../Components/Helpers/Modal";
import { Token } from "../../../Models/Authentication";

export type IReauthenticatorFormProps = IMutator<Token>;

export interface IReauthenticatorProps extends IMutator<Token> {
  /** Boolean flag indicating if the reauthentication form should be rendered to the user. */
  show: boolean;
  /** Callback to update the show state of the reauthentication form. */
  setShow: Dispatch<boolean>;
  /** The form component for authorization. */
  AuthForm: React.FC<IReauthenticatorFormProps>;
}

/** Renders an authentication form which matches the specified auth method.
 * @remarks Since the auth forms contain hooks, they must be instantiated in the parent component unconditionally before
 * rendering. An attempt to use `authTypeFormMap[authType]({ onChange: handleChange })` will throw React errors due to
 * hooks being mounted conditionally.
 */
const Reauthenticator: React.FC<IReauthenticatorProps> = ({ AuthForm, show, onChange, setShow }) => {
  const handleChange = useCallback((change: Token) => {
    onChange(change);
    setShow(false);
  }, []);
  return (
    <Modal title={"Security Token Expired"} open={show}>
      <Stack spacing={2}>
        <Typography variant="body1">
          Your security token has expired. Please re-authorize the application using the below form:
        </Typography>
        {AuthForm({ onChange: handleChange })}
      </Stack>
    </Modal>
  );
};

export default Reauthenticator;
